


'use client';
import Image from 'next/image';
import Link from 'next/link';

const FooterSection = () => {
  return (
    <footer className="w-full max-w-[1420px] mx-auto bg-[#fa4b7f] rounded-t-2xl px-6 py-6 sm:px-10 sm:py-10 lg:px-20 lg:py-12 flex justify-between items-center">
      
      {/* Left: Logo / Title */}
      <div className="flex flex-col">
        
        <Link href="/" target="_blank">
          <Image
            src="/images/footer-logo.webp" // Update this to your actual icon file
            alt="footer-logo"
            width={158}
            height={64}
           unoptimized
          />
        </Link>
      </div>
      

      {/* Right: Social Icons */}
      <div className="flex gap-5 sm:gap-6 lg:gap-8 items-center">
        
        {/* X */}
        <Link href="https://x.com/EmpowHERinAI" target="_blank" rel="noopener noreferrer nofollow">
          <Image
            src="/images/x-twitter.webp" // Update this to your actual icon file
            alt="X"
            width={20}
            height={20}
            className="w-[18px] h-[18px]"
            unoptimized
          />
        </Link>

        {/* Instagram */}
        {/* <Link href="https://www.instagram.com/empowherinai" target="_blank" rel="noopener noreferrer nofollow">
          <Image
            src="/images/instagram.webp" // Replace with your icon
            alt="instagram"
            width={20}
            height={20}
            className="w-[18px] h-[18px]"
            unoptimized
          />
        </Link> */}

        {/* Telegam */}
        <Link href="http://t.me/EmpowHERinAI" target="_blank" rel="noopener noreferrer nofollow">
          <Image
            src="/images/telegram.webp" // Replace with your icon
            alt="Telegram"
            width={20}
            height={20}
            className="w-[18px] h-[18px]"
            unoptimized
          />
        </Link>

        {/* MailId */}
        <a href="mailto:info@empowherinai.com" rel="noopener noreferrer">
          <Image
            src="/images/mailid.webp" // Replace with your icon
            alt="MailId"
            width={20}
            height={20}
            className="w-[18px] h-[18px]"
            unoptimized
          />
        </a>
      </div>
    </footer>
  );
};

export default FooterSection;
